export const guideAbout = {
  lastUpdated: 'LastUpdated',
  gameVersion: 'GameVersion',
}
